import React, { FC } from 'react'
import cx from 'classnames'

import { ActionButtonProps } from '../ActionButton'
import { Image } from '../../types'

import * as SC from './styled'

export type GDPRBannerProps = {
  className?: string
  logo: Image
  title: string
  description: string
  buttons: {
    accept: ActionButtonProps
    refuse: ActionButtonProps
  }
  gdprSettings: {
    title: string
    onClick: () => void
  }
}

const GDPRBanner: FC<GDPRBannerProps> = (props) => {
  const { className, logo, title, description, gdprSettings, buttons } = props

  return (
    <SC.GpdrOverlay className={cx(className)}>
      <SC.Container>
        <SC.Wrapper>
          <SC.Logo src={logo.src} alt={logo.alt} />
          <SC.Title>{title}</SC.Title>
          <SC.DescriptionWrapper>
            <SC.Description dangerouslySetInnerHTML={{ __html: description }}></SC.Description>
            <SC.GdprSettings onClick={gdprSettings.onClick}>{gdprSettings.title}</SC.GdprSettings>
          </SC.DescriptionWrapper>
          <SC.ButtonsWrapper>
            <SC.ButtonAccept {...buttons.accept} />
            <SC.ButtonRefuse {...buttons.refuse} />
          </SC.ButtonsWrapper>
        </SC.Wrapper>
      </SC.Container>
    </SC.GpdrOverlay>
  )
}

export default GDPRBanner
